import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SwitchControlComponent } from '../../shared/controls/switch-control/switch-control.component';

import { ErrorService } from '../../shared/services/error-service';
import { ToastService } from '../../shared/toast/toast.service';
import { LoadingService } from '../../shared/services/loading.service';
import { LoadingHelper } from '../../shared/services/loading-helper';

import { CreateTenantInput, TenantService, UpdateTenantInput } from '../../../service/proxy';


@Component({
    templateUrl: './create-or-update-tenant.component.html',
    styleUrl: './create-or-update-tenant.component.scss',

    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SwitchControlComponent
    ],

    providers: [
        TenantService
    ],
})
export class CreateOrUpdateTenantComponent implements OnInit {
    public tenantId: number = 0;
    public tenant: any = {
        tenantName: '',
        managerEmail: '',
        database: {
            host: '',
            catalog: '',
            username: '',
            password: '',
            trustCertificate: false,
            integratedSecurity: false
        }
    };

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private tenantService: TenantService,
        private errorService: ErrorService,
        private toastService: ToastService,
        private loadingService: LoadingService) {}

    ngOnInit() {
        this.route.paramMap
            .subscribe(params => {
                this.tenantId = Number(params.get('id'));

                if (this.tenantId > 0) {
                    this.getTenantById(this.tenantId);
                }
            }
        );
    }

    getTenantById(tenantId: number): void {
        this.tenantService.getTenantById(this.tenantId)
            .subscribe({
                next: (data) => {
                    this.tenant = data;
                    this.tenant.database = data.database || {};

                    this.clearCredentials();
                },
                error: (error) => {
                    this.errorService.handleError(error);
                }
            }
        );
    }

    clearCredentials(): void {
        if (this.tenant.database.integratedSecurity) {
            this.tenant.database.username = '';
            this.tenant.database.password = '';
        }
    }

    onSave(form: any): void {
        if (!form.valid) {
            return;
        }

        if (this.tenantId <= 0) {
            this.createTenant();
        }
        else {
            this.updateTenant();
        }
    }

    createTenant() {
        const input = this.tenant as CreateTenantInput;

        LoadingHelper.withLoading(
            this.tenantService.createTenant(input),
            this.loadingService
        ).subscribe({
            next: () => {
                this.toastService.show('Tenant created successfully.', 'success');

                setTimeout(() => {
                    this.router.navigate(['/tenant']);
                }, 2000);
            },
            error: (error: any) => {
                this.toastService.show('Failed to create tenant.', 'error');
                this.errorService.handleError(error);
            }
        });
    }

    updateTenant() {
        const input = this.tenant as UpdateTenantInput;

        LoadingHelper.withLoading(
            this.tenantService.updateTenant(this.tenantId, input),
            this.loadingService
        ).subscribe({
            next: () => {
                this.toastService.show('Tenant updated successfully.', 'success');

                setTimeout(() => {
                    this.router.navigate(['/tenant']);
                }, 2000);
            },
            error: (error: any) => {
                this.toastService.show('Failed to update tenant.', 'error');
                this.errorService.handleError(error);
            }
        });
    }

    onCancel() {
        this.router.navigate(['/tenant']);
    }
}